<template>
  <div class="flex flex-wrap col-12 border-box white-bg" :class="[{'body-padding-desktop': !newCustomer}]">
    <div v-if="!newCustomer && !isUser" class="col-12 m1">
      <span class="h6">Mettez à jour les informations personnelles de {{ customer.firstname }} {{ customer.lastname }} : </span>
    </div>
    <GenerateForm
      :data="customer"
      :form-type="typeOfForm"
    />
  </div>
</template>

<script>
import GenerateForm from '@/components/form/GenerateForm.vue';
import { computeDataLayerWithoutRoute } from '@/utils/index';

export default {
  components: { GenerateForm },
  props: {
    customer: {
      type: Object,
      default: () => {}
    },
    isUser: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newCustomer () {
      return !Object.keys(this.customer || {}).length;
    },
    typeOfForm () {
      return this.newCustomer ? 'createCustomer' : 'editCustomer';
    }
  },
  mounted () {
    if (this.isUser) {
      this.$store.commit('setSubscriptionHeader', { title: 'Informations personnelles', subtitle: 'Mettez à jour vos informations personnelles.' });
      computeDataLayerWithoutRoute('editUser');
      return;
    }
    this.$store.commit('setSubscriptionHeader', { title: 'Informations personnelles', subtitle: 'Qui va utiliser l\'abonnement ?' });
    if (!this.newCustomer) {
      computeDataLayerWithoutRoute('editParticipant');
    }
  }
};
</script>
